export const SET_GENERIC_FORM_VALUE = 'SET_GENERIC_FORM_VALUE';
export const SET_GENERIC_FORM_IS_SUBMITTED = 'SET_GENERIC_FORM_IS_SUBMITTED';
export const INIT_GENERIC_FORM = 'INIT_GENERIC_FORM';
export const SET_GENERIC_FORM_IS_SUBMITTING = 'SET_GENERIC_FORM_IS_SUBMITTING';
export const DELETE_FORM = 'DELETE_FORM';
